import { Button } from "antd";
import { useState } from "react";
import { Text, Text3 } from "./custom/Typography";
import WarningIcon from "../images/Action/warning.svg";
import ModalCustom from "./modal-custom";
import { Image } from "react-bootstrap";
import { delLocationOrgs } from "../services/setting/locations/location-assign";
import AlertSuccess from "../alert/AlertSuccess";
import { useTranslation } from "react-i18next";

const modalConfirmFooterButtonStyle = {
  background: "var(--color-functional-foreground-error)",
  color: "var(--color-on-primary-content-high)",
  border: "none",
  fontWeight: 500,
};

export default function ModalRemove({
  open,
  onCancel,
  data,
  fnDone = () => {},
  successText,
}) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const handleConfirmRemove = async () => {
    setIsLoading(true);
    const body = {
      office_location_ids: data.office_location_ids,
      org_id: data.org_id,
    };

    const res = await delLocationOrgs(body, true);
    setIsLoading(false);
    if (!res) return;
    if (res.status) {
      onCancel();
      AlertSuccess(successText);
      fnDone();
    }
  };

  return (
    <ModalCustom
      centered
      closable={false}
      open={open}
      onCancel={onCancel}
      title={null}
      width={391}
      footer={
        <div className="d-flex gap-4 mt-5 justify-content-center w-100">
          <Button
            // size="large"
            disabled={isLoading}
            style={{
              width: "50%",
              height: 40,
              borderColor: "var(--color-on-base-border-default, #E6E9F5)",
              fontWeight: 500,
            }}
            onClick={onCancel}
          >
            {t("hrms_setting_location_no_rm_modal")}
          </Button>
          <Button
            disabled={isLoading}
            type="primary"
            style={{
              width: "50%",
              height: 40,
              ...modalConfirmFooterButtonStyle,
            }}
            // size="large"
            onClick={handleConfirmRemove}
          >
            {t("hrms_setting_location_title_rm_modal")}
            {isLoading && "..."}
          </Button>
        </div>
      }
    >
      <div className="d-flex flex-column align-items-center text-center">
        <div
          style={{
            width: 120,
            height: 120,
            borderRadius: "50%",
            background: "var(--color-primary-foreground-subtle-hover)",
            color: "var(--color-primary-content-default)",
          }}
          className="d-inline-flex  align-items-center justify-content-center"
        >
          <Image src={WarningIcon} width={74} height={74} alt="warning" />
        </div>
        <Text3 size="20px" className="mt-3">
          {t("hrms_setting_location_title_rm_modal")}
        </Text3>
      </div>
      <Text size="16px" className="text-center mt-2">
        {t("hrms_setting_location_sub_title_rm_modal")}
      </Text>
    </ModalCustom>
  );
}
